import { defineStore } from "pinia";
import { selectProduct } from "@/services/apiCalls/user";
import { PRODUCTS, PRODUCT_META } from "@/services/products";

/**
 * Tracks which product suite app (RepSignal / MarketSignal) the user is in.
 * The server is the source of truth (`User.selected_product`); this store is
 * hydrated from `/api/user/info` and mirrors the choice locally so the UI
 * renders correctly before the next fetch completes.
 */
export const useProductStore = defineStore({
  id: "product",
  state: () => ({
    selected: PRODUCTS.REPSIGNAL,
    enableMarketSignal: false,
    enableRepSignal: true,
  }),
  persist: true,
  getters: {
    isMarketSignal() {
      // MarketSignal-only users are always in MarketSignal
      return (
        this.enableMarketSignal &&
        (this.selected === PRODUCTS.MARKETSIGNAL || !this.enableRepSignal)
      );
    },
    homeRouteName() {
      return this.isMarketSignal
        ? PRODUCT_META[PRODUCTS.MARKETSIGNAL].homeRoute
        : PRODUCT_META[PRODUCTS.REPSIGNAL].homeRoute;
    },
  },
  actions: {
    hydrate(data) {
      this.enableMarketSignal = Boolean(data.enable_market_signal);
      // Missing means the server predates the flag, so keep RepSignal
      this.enableRepSignal = data.repsignal_access !== false;
      this.selected = PRODUCT_META[data.selected_product]
        ? data.selected_product
        : PRODUCTS.REPSIGNAL;
    },
    async select(product) {
      if (!PRODUCT_META[product] || product === this.selected) {
        return;
      }
      if (product === PRODUCTS.REPSIGNAL && !this.enableRepSignal) {
        return;
      }
      if (product === PRODUCTS.MARKETSIGNAL && !this.enableMarketSignal) {
        return;
      }
      const result = await selectProduct(product);
      this.selected = result.selected_product;
    },
  },
});
